import type { ThemeKey, DefaultThemeStyles } from 'Src/types/theme';
import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { COLORS } from 'Components/utils/color/colors';
import { NavTag } from 'Components/frameworks/nav-tag/NavTag';
import { themes } from './AnchorsList.themes';
type Props = {
  className?: string;
  items: Array<{
    className?: string;
    enabled?: boolean;
    id: string;
    isActive?: boolean;
    label: ReactNode;
    onClick?: () => void;
    url?: string;
  }>;
  theme?: ThemeKey<typeof themes>;
};
export const AnchorsList = ({ className, items = [], theme = 'default', ...rest }: Props) => {
  if (!items.length) {
    return null;
  }

  const { thListItem, thNavTagTheme, thRoot } = themes[theme] as DefaultThemeStyles<typeof themes>;
  return (
    <ul {...rest} className={classnames(thRoot, className)}>
      {items.map(({ enabled, id, isActive, label, url, ...item }) => (
        <li className={thListItem} data-testid={`CTA-${id}`} key={id}>
          <NavTag
            {...item}
            colorActive={COLORS.BLACK}
            colorUnactive={COLORS.WHITE}
            href={url}
            isActive={isActive}
            theme={thNavTagTheme as 'default' | 'reverse'}
          >
            {label}
          </NavTag>
        </li>
      ))}
    </ul>
  );
};
